/**
 * @generated SignedSource<<983c06ed6f589597d46b7aa1593dd6a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PianofunclubEnrolmentModelStatusChoices = "ARCHIVED" | "ENROLED" | "OFFERED" | "WAITING_LIST" | "%future added value";
export type EnrolPupilInput = {
  clientMutationId?: string | null | undefined;
  enrolmentId: string;
  lessonBlockId?: string | null | undefined;
};
export type EnrolPupilMutation$variables = {
  input: EnrolPupilInput;
};
export type EnrolPupilMutation$data = {
  readonly enrolPupil: {
    readonly enrolment: {
      readonly enroledParent: {
        readonly id: string;
        readonly user: {
          readonly firstName: string;
          readonly id: string;
          readonly lastName: string;
        };
      } | null | undefined;
      readonly enroledPupil: {
        readonly id: string;
        readonly user: {
          readonly firstName: string;
          readonly id: string;
          readonly lastName: string;
        };
      } | null | undefined;
      readonly enroledTimestamp: string | null | undefined;
      readonly id: string;
      readonly positionInWaitingList: number | null | undefined;
      readonly status: PianofunclubEnrolmentModelStatusChoices;
    } | null | undefined;
    readonly errors: any | null | undefined;
    readonly lessonBlock: {
      readonly id: string;
      readonly pupil: {
        readonly id: string;
        readonly user: {
          readonly firstName: string;
          readonly id: string;
          readonly lastName: string;
        };
      } | null | undefined;
    } | null | undefined;
    readonly success: boolean | null | undefined;
    readonly updatedEnrolmentOffers: ReadonlyArray<{
      readonly archived: boolean;
      readonly id: string;
      readonly offerAccepted: boolean;
    } | null | undefined> | null | undefined;
    readonly updatedEnrolmentsInWaitingList: ReadonlyArray<{
      readonly id: string;
      readonly positionInWaitingList: number | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type EnrolPupilMutation = {
  response: EnrolPupilMutation$data;
  variables: EnrolPupilMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "positionInWaitingList",
  "storageKey": null
},
v3 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "DjangoUserNode",
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EnrolPupilPayload",
    "kind": "LinkedField",
    "name": "enrolPupil",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EnrolmentNode",
        "kind": "LinkedField",
        "name": "enrolment",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enroledTimestamp",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProfileNode",
            "kind": "LinkedField",
            "name": "enroledParent",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProfileNode",
            "kind": "LinkedField",
            "name": "enroledPupil",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LessonBlockNode",
        "kind": "LinkedField",
        "name": "lessonBlock",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProfileNode",
            "kind": "LinkedField",
            "name": "pupil",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EnrolmentOfferNode",
        "kind": "LinkedField",
        "name": "updatedEnrolmentOffers",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "archived",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "offerAccepted",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EnrolmentNode",
        "kind": "LinkedField",
        "name": "updatedEnrolmentsInWaitingList",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EnrolPupilMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EnrolPupilMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "bc6fbf78c914ea4928e395c56daccb24",
    "id": null,
    "metadata": {},
    "name": "EnrolPupilMutation",
    "operationKind": "mutation",
    "text": "mutation EnrolPupilMutation(\n  $input: EnrolPupilInput!\n) {\n  enrolPupil(input: $input) {\n    success\n    errors\n    enrolment {\n      id\n      status\n      enroledTimestamp\n      positionInWaitingList\n      enroledParent {\n        id\n        user {\n          id\n          firstName\n          lastName\n        }\n      }\n      enroledPupil {\n        id\n        user {\n          id\n          firstName\n          lastName\n        }\n      }\n    }\n    lessonBlock {\n      id\n      pupil {\n        id\n        user {\n          id\n          firstName\n          lastName\n        }\n      }\n    }\n    updatedEnrolmentOffers {\n      id\n      archived\n      offerAccepted\n    }\n    updatedEnrolmentsInWaitingList {\n      id\n      positionInWaitingList\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "083db3e0d55c726f24825510a9a6d60f";

export default node;
